import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import PropTypes from 'prop-types';

const Confirm = ({
  title,
  question,
  yesLabel,
  otherLabel,
  noLabel,
  onConfirm,
  onCancel,
  onOther,
  color,
}) => {
  const modalClass = 'modal-dialog--header';

  Confirm.propTypes = {
    title: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    yesLabel: PropTypes.string,
    otherLabel: PropTypes.string,
    noLabel: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    onOther: PropTypes.func.isRequired,
    color: PropTypes.string,
  };

  Confirm.defaultProps = {
    yesLabel: 'Si',
    noLabel: 'No, Volver',
    color: 'warning',
    onCancel: () => { },
  };

  const customUI = ({ onClose }) => (
    <div>
      <Modal
        size="md"
        isOpen
        modalClassName="modal ltr-support"
        className={`modal-dialog--${color || 'warning'} ${modalClass}`}
      >
        <div className="modal__header">
          <h4 className="text-modal  modal__title">{title}</h4>
        </div>
        <div className="modal__body">
          {question}
        </div>
        <ButtonToolbar className="modal__footer">
          <Button
            className="modal_cancel"
            onClick={() => {
              if (onCancel) {
                onCancel();
              }
              onClose();
            }}
          >
            {noLabel}
          </Button>
          {
            otherLabel && (
              <Button
                className="modal_ok"
                color={color || 'warning'}
                onClick={() => {
                  onOther();
                  onClose();
                }}
              >
                {otherLabel}
              </Button>
            )
          }
          <Button
            className="modal_ok"
            color={color || 'warning'}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {yesLabel}
          </Button>
        </ButtonToolbar>
      </Modal>
    </div>
  );

  customUI.propTypes = {
    onClose: PropTypes.func.isRequired,
  };

  confirmAlert({
    customUI,
  });
};

export default Confirm;
